import script from "./DocumentsVuetable.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsVuetable.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsVuetable.vue?vue&type=style&index=0&id=5782af1f&lang=scss"

const __exports__ = script;

export default __exports__